module.exports = __webpack_public_path__ + "img/map.351096c6.svg";